<div class="tw-flex tw-items-center tw-justify-between lg:tw-justify-start tw-gap-0 lg:tw-gap-2 tw-w-full">
  @for (node of path().nodes; track node.id; let i = $index; let last = $last) {
    <div
      class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-shrink-0 tw-w-20 lg:tw-w-24 tw-h-[72px] lg:tw-h-20 tw-px-2 tw-py-[11px] tw-gap-2 tw-rounded-lg tw-bg-gray-50 tw-border tw-border-solid tw-border-gray-200"
    >
      @if (node.type === 'brand') {
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1.5 lg:tw-gap-2">
          <img [src]="assets.fox" alt="" class="tw-h-[25px] tw-w-[17px] lg:tw-h-[30px] lg:tw-w-5 tw-object-contain" />
          <img [src]="assets.wordmark" alt="MICEtribe" class="tw-h-[7px] tw-w-10 lg:tw-h-[9px] lg:tw-w-12 tw-object-contain" />
        </div>
      } @else {
        <img [src]="nodeIcon(node.type)" alt="" class="tw-h-4 tw-w-4 lg:tw-h-5 lg:tw-w-5 tw-object-contain" />
        <div>
          @for (line of node.labels; track line) {
            <p class="tw-m-0 tw-text-[10px] lg:tw-text-xs tw-leading-[10px] tw-text-gray-500 tw-text-center tw-font-medium tw-font-inter">{{ line }}</p>
          }
        </div>
      }
    </div>

    @if (!last) {
      @if (linkAt(i); as link) {
        <!-- Mobile compact connector  -->
        @switch (link.mobileConnector) {
          @case ('bidirectional') {
            <img [src]="assets.arrowBidirectional" alt="" class="tw-size-3.5 tw-shrink-0 lg:tw-hidden" />
          }
          @case ('bidirectionalGrayRed') {
            <img [src]="assets.arrowBidirectionalGrayRed" alt="" class="tw-size-3.5 tw-shrink-0 lg:tw-hidden" />
          }
          @case ('forward') {
            <img [src]="assets.arrowRightMobile" alt="" class="tw-size-3.5 tw-shrink-0 lg:tw-hidden" />
          }
          @default {
            <img [src]="assets.arrowRightRed" alt="" class="tw-size-3.5 tw-shrink-0 lg:tw-hidden" />
          }
        }

        <!-- Desktop labeled connector -->
        <div class="tw-hidden lg:tw-flex tw-flex-1 tw-flex-col tw-gap-[3px] tw-items-center tw-min-w-0">
          @if (link.forwardLabel) {
            <p
              class="tw-m-0 tw-w-full tw-text-center tw-text-[11px] tw-font-medium tw-font-inter tw-leading-[1.45]"
              [ngClass]="toneClass(link.forwardTone)"
            >
              {{ link.forwardLabel }}
            </p>
          }

          @if (hasReverseArrow(link)) {
            <img [src]="assets.arrowRight" alt="" class="tw-h-2.5 tw-w-[120px] tw-max-w-full tw-object-contain" />
            <img [src]="reverseArrowSrc(link)" alt="" class="tw-h-2.5 tw-w-[120px] tw-max-w-full tw-object-contain" />
            @if (link.reverseLabel) {
              <p
                class="tw-m-0 tw-w-full tw-text-center tw-text-[11px] tw-font-medium tw-font-inter tw-leading-[1.45]"
                [ngClass]="toneClass(link.reverseTone)"
              >
                {{ link.reverseLabel }}
              </p>
            }
          } @else if (link.forwardTone === 'danger') {
            <img [src]="assets.lineRed" alt="" class="tw-h-2.5 tw-w-[132px] tw-max-w-full tw-object-contain" />
          } @else {
            <img [src]="assets.arrowRight" alt="" class="tw-h-2.5 tw-w-[120px] tw-max-w-full tw-object-contain" />
          }
        </div>
      }
    }
  }
</div>
